module.exports = __webpack_public_path__ + "img/dash.40af2973.svg";